import { render, staticRenderFns } from "./Recognize.vue?vue&type=template&id=25054256&scoped=true"
import script from "./Recognize.vue?vue&type=script&lang=js"
export * from "./Recognize.vue?vue&type=script&lang=js"
import style0 from "./Recognize.vue?vue&type=style&index=0&id=25054256&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25054256",
  null
  
)

export default component.exports